import {Tabs, Tab, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import StatsMonthMatrix from './StatsMonthMatrix.js';
import {TAB_TIME, TAB_YEAR} from './StatsCommon.js';
import StatsMonthSum from './StatsMonthSum.js';
import StatsWinter from './StatsWinter.js';
import StatsMonth from './StatsMonth.js';
import StatsDate from './StatsDate.js';
import StatsYear from './StatsYear.js';
import StatsDay from './StatsDay.js';

const StatsTime = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	const handleTabChange = (event, tab) => {
		gStorage.stats.setObsList(null);
		gStorage.stats.setTimeTab(tab + TAB_YEAR);
	}

	if (gStorage.stats.tab !== TAB_TIME)
		return null;

	return (
		<>
			<Grid container direction="row" justifyContent="center" spacing={0} columns={1}>
				<Tabs
					value={gStorage.stats.time_tab - TAB_YEAR}
					onChange={handleTabChange} 
					align={'center'}
					indicatorColor="primary"
					textColor="primary"
					scrollButtons="auto"
					variant="scrollable"
					sx={{mb: 1}}>
					<Tab label={t('stats.year')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.month')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.month_matrix')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.date')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.month_sum')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.day')} disabled={!gStorage.conn.online}/>
					<Tab label={t('stats.winter')} disabled={!gStorage.conn.online}/>
				</Tabs>
			</Grid>

			<StatsYear/>
			<StatsMonth/>
			<StatsMonthMatrix/>
			<StatsDate/>
			<StatsMonthSum/>
			<StatsDay/>
			<StatsWinter/>
		</>
	);
});

export default StatsTime;
